/**
 * Inline edit panel for a sub-unit. Renders directly below the UnitTabsBar
 * when the user clicks the pencil icon on a pill. Submit applies the new
 * suffix; Delete removes the unit; Cancel closes the panel without changes.
 *
 * Suffix input auto upper-cases and converts whitespace to underscores so
 * the resulting unit_order_number stays scan/URL-safe (e.g. "left wing" →
 * "LEFT_WING" → "IN101079.LEFT_WING").
 */

import React, { useState, useEffect } from 'react';
import { TextField } from '@mui/material';
import { Row, Col } from 'react-bootstrap';
import { MyDiv } from '../Pages/Common/Components';
import '../styles/UnitEditPanel.scss';

const MAX_SUFFIX_LENGTH = 8;

const UnitEditPanel = ({ unit, orderUniqueId, onSubmit, onDelete, onCancel }) => {
  const [suffix, setSuffix] = useState(unit?.unit_id || '');

  useEffect(() => {
    if (!unit) return;
    setSuffix(unit.unit_id || '');
  }, [unit]);

  if (!unit) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    const trimmedSuffix = suffix.trim().toUpperCase().replace(/\s+/g, '_');
    if (!trimmedSuffix) return;
    onSubmit({ suffix: trimmedSuffix });
  };

  return (
    <MyDiv className="unit-edit-panel">
      <div className="unit-edit-panel__header">
        <div>
          <h5 className="unit-edit-panel__title">Edit unit</h5>
          <p className="unit-edit-panel__subtitle">
            Update the suffix for <strong>{unit.unit_order_number}</strong>.
          </p>
        </div>
      </div>

      <form onSubmit={handleSubmit}>
        <Row className="g-3">
          <Col xs={12} md={6}>
            <TextField
              required
              label={`Suffix (after "${orderUniqueId || ''}.")`}
              variant="outlined"
              size="small"
              value={suffix}
              onChange={(e) => setSuffix(e.target.value)}
              fullWidth
              autoFocus
              helperText={`e.g. U1, APRONS, LEFT — auto upper-cased, max ${MAX_SUFFIX_LENGTH} characters`}
              inputProps={{ maxLength: MAX_SUFFIX_LENGTH }}
            />
          </Col>
        </Row>

        <div className="unit-edit-panel__actions">
          <button
            type="button"
            className="unit-edit-panel__btn unit-edit-panel__btn--cancel"
            onClick={onCancel}
          >
            Cancel
          </button>
          <button
            type="button"
            className="unit-edit-panel__btn unit-edit-panel__btn--delete"
            onClick={() => onDelete(unit)}
          >
            Delete unit
          </button>
          <button
            type="submit"
            className="unit-edit-panel__btn unit-edit-panel__btn--submit"
          >
            Save changes
          </button>
        </div>
      </form>
    </MyDiv>
  );
};

export default UnitEditPanel;
